import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";
import { BodyPostGrade, ResponseGetGrade, ResponseGetIdGrade, ResponsePostGrade } from "./interfaceGrade";

export const getGrade = async (id?: string): Promise<ResponseGetGrade[]> => {
    try {
        const data = await getApi(`/grade/level/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetGrade[];
    }
}


export const postGrade = async (body: BodyPostGrade): Promise<ResponsePostGrade> => {
    try {
        const data = await postApi('/grade', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePostGrade;
    }
}


export const patchGrade = async (body: BodyPostGrade, id?:number): Promise<ResponsePostGrade> => {
    try {
        const data = await patchApi(`/grade/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsePostGrade;
    }
}


export const getGradeId = async (term?: number): Promise<ResponseGetIdGrade> => {
    try {
        const data = await getApi(`/grade/${term}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetIdGrade;
    }
}


export const deleteGrade = async (term: number): Promise<any> => {
    try {
        const data = await deleteApi(`/grade/${term}`, term);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

